import React from "react";
import './home.css'
import BaseHomeComp from "./base";


const HomePage = () => {
    return (
        <>
            <BaseHomeComp />
        </>

    )
}

export default HomePage
